<div *ngIf="showAddress">
  <section fxLayout="column" fxLayoutAlign=" start">
    <mat-form-field appearance="outline" *ngIf="showContact">
      <mat-label>Kontaktart</mat-label>
      <mat-select [(ngModel)]="data.contactType">
        <mat-option value="PERSON">Person</mat-option>
        <mat-option value="COMPANY">Firma</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlexAlign="stretch">
      <mat-label>Firma</mat-label>
      <input matInput type="text" [disabled]="disableFieldsForInstaller" [(ngModel)]="data.company" />
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlexAlign="stretch">
      <mat-label>Firma Zusatz</mat-label>
      <input matInput type="text" [disabled]="disableFieldsForInstaller" [(ngModel)]="data.companyAddition" />
    </mat-form-field>

    <div fxLayout="row" fxFlexAlign="stretch" fxLayoutGap="20px">
      <div fxFlex>
        <mat-form-field appearance="outline" fxFlex="100">
          <mat-label>Straße</mat-label>
          <input matInput type="text" [disabled]="disableFieldsForInstaller" [(ngModel)]="data.street" />
        </mat-form-field>
      </div>

      <div>
        <mat-form-field appearance="outline">
          <mat-label>Hausnummer</mat-label>
          <input matInput type="text" [disabled]="disableFieldsForInstaller" [(ngModel)]="data.streetNo" />
        </mat-form-field>
      </div>
    </div>

    <div fxLayout="row" fxFlexAlign="stretch" fxLayoutGap="20px">
      <div>
        <mat-form-field appearance="outline">
          <mat-label>PLZ</mat-label>
          <input
            matInput
            [(ngModel)]="data.zipCode"
            [disabled]="disableFieldsForInstaller"
            name="zipCode"
            type="text"
            #zipCode="ngModel"
            minlength="5"
            maxlength="5" />
          <mat-error *ngIf="zipCode.invalid && (zipCode.dirty || zipCode.touched)">
            Eine Postleitzahl muss genau 5 Zeichen haben.
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="70">
        <mat-form-field appearance="outline" fxFlex="100">
          <mat-label>Ort</mat-label>
          <input matInput type="text" [disabled]="disableFieldsForInstaller" [(ngModel)]="data.city" />
        </mat-form-field>
      </div>
    </div>
    <app-hint-card *ngIf="infoText" [outlined]="true">{{ infoText }}</app-hint-card>
    <div
      fxLayout="row"
      fxFlexAlign="stretch"
      fxLayoutGap="20px"
      *ngIf="!(hideDuplicateContactFields && showContact)">
      <div fxFlex="50">
        <mat-form-field appearance="outline" fxFlex="100">
          <mat-label>E-Mail</mat-label>
          <input matInput type="text" [(ngModel)]="data.mail" />
        </mat-form-field>
      </div>
      <div fxFlex="25">
        <mat-form-field appearance="outline" fxFlex="100">
          <mat-label>Telefon</mat-label>
          <input matInput type="text" [(ngModel)]="data.phone" />
        </mat-form-field>
      </div>
      <div fxFlex="25">
        <mat-form-field appearance="outline" fxFlex="100">
          <mat-label>Handy</mat-label>
          <input matInput type="text" [(ngModel)]="data.mobile" />
        </mat-form-field>
      </div>
    </div>

    <mat-form-field appearance="outline" fxFlexAlign="stretch">
      <mat-label>Land</mat-label>
      <input matInput type="text" [(ngModel)]="data.country" />
    </mat-form-field>
  </section>
</div>

<!-- -->
<div *ngIf="showContact">
  <h3>Ansprechpartner</h3>
  <section fxLayout="column" fxLayoutAlign=" start">
    <mat-form-field appearance="outline">
      <mat-label>Anrede</mat-label>
      <mat-select [(ngModel)]="data.salutation">
        <mat-option *ngFor="let ele of metaService.salutationValues$ | async" [value]="ele.id">
          {{ ele.title }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlexAlign="stretch">
      <mat-label>Vorname</mat-label>
      <input matInput type="text" [disabled]="disableFieldsForInstaller" [(ngModel)]="data.firstName" />
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlexAlign="stretch">
      <mat-label>Nachname</mat-label>
      <input matInput type="text" [disabled]="disableFieldsForInstaller" [(ngModel)]="data.lastName" />
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlexAlign="stretch">
      <mat-label>Abteilung</mat-label>
      <input matInput type="text" [(ngModel)]="data.department" />
    </mat-form-field>

    <div fxLayout="row" fxFlexAlign="stretch" fxLayoutGap="20px">
      <div fxFlex="50">
        <mat-form-field appearance="outline" fxFlex="100">
          <mat-label>Telefonnummer</mat-label>
          <input matInput type="text" [(ngModel)]="data.phone" />
        </mat-form-field>
      </div>
      <div fxFlex="50">
        <mat-form-field appearance="outline" fxFlex="100">
          <mat-label>Handynummer</mat-label>
          <input matInput type="text" [(ngModel)]="data.mobile" />
        </mat-form-field>
      </div>
    </div>

    <mat-form-field appearance="outline" fxFlexAlign="stretch" *ngIf="!disableFieldsForInstaller">
      <mat-label>E-Mail</mat-label>
      <input
        matInput
        [(ngModel)]="data.mail"
        name="mail"
        type="email"
        #mail="ngModel"
        [pattern]="RegexToCheckEMail" />
      <mat-hint>
        Keine Leerzeichen oder Sonderzeichen wie „
        <strong>, ; : < > ( ) [ ] \</strong>
        “. Ein Punkt darf nicht am Anfang, am Ende oder direkt vor dem „
        <strong>&#64;</strong>
        “ stehen.
      </mat-hint>
      <mat-error *ngIf="mail.invalid && (mail.dirty || mail.touched)">
        <div *ngIf="mail?.errors.pattern">das Format der Mail Adresse ist ungültig</div>
      </mat-error>
    </mat-form-field>
  </section>
</div>
